const deleteSites = {
  toastr: 'Site deletado',
  toastr1: ' deletado com sucesso'
};

export default deleteSites;
